import React from 'react';
import {TestSpeechSynthesis} from "../features/test_speechsynthesis/index";

const TestSpeechSynthesisPage = () => {
    return (
        <TestSpeechSynthesis/>
    );
};

export {TestSpeechSynthesisPage};